import React, { useMemo } from 'react';
import { Table } from 'antd';
import type { TableColumnsType } from 'antd';
import { useTranslation } from 'react-i18next';
import { WarehouseWorkStatTypeInfo } from '../../graphql/queries/getWorkProgressData';

export interface AccountScanningData {
  accountId: string;
  account: string;
  accountPhone?: number | null;
  [key: string]: string | number | null | undefined; // 动态字段，key为legendKey
}

interface AccountScanningTableProps {
  data: AccountScanningData[];
  loading?: boolean;
  statTypes: WarehouseWorkStatTypeInfo[];
}

const AccountScanningTable: React.FC<AccountScanningTableProps> = ({ data, loading, statTypes }) => {
  const { t } = useTranslation();

  const columns: TableColumnsType<AccountScanningData> = useMemo(() => {
    const baseColumns: TableColumnsType<AccountScanningData> = [
      {
        title: 'Account',
        dataIndex: 'account',
        key: 'account',
        width: 150,
        align: 'left',
        render: (account: string, record: AccountScanningData) => {
          if (record.accountPhone) {
            return `${account} (${record.accountPhone})`;
          }
          return account;
        },
        sorter: (a: AccountScanningData, b: AccountScanningData) => {
          const aAccount = a.account || '';
          const bAccount = b.account || '';
          return aAccount.localeCompare(bAccount);
        },
        defaultSortOrder: 'ascend' as const,
      },
    ];

    // 根据statTypes动态生成列
    const statColumns = statTypes.map(statType => ({
      title: t(`wms.progress.workProgress.statType.${statType.legendKey}`),
      dataIndex: statType.legendKey,
      key: statType.legendKey,
      width: 120,
      align: 'left' as const,
      render: (value: number) => value || 0,
      sorter: (a: AccountScanningData, b: AccountScanningData) => {
        const aValue = (a[statType.legendKey] as number) || 0;
        const bValue = (b[statType.legendKey] as number) || 0;
        return aValue - bValue;
      },
    }));

    return [...baseColumns, ...statColumns];
  }, [statTypes, t]);

  return (
    <div>
      <Table
        columns={columns}
        dataSource={data}
        rowKey="accountId"
        loading={loading}
        pagination={false}
        size="middle"
        bordered={false}
       className="mb-4"/>
      {/* 合计显示 */}
      <div className="flex justify-between items-center">
        <div className="text-gray-500">
          {t('table.pagination.totalItems', { total: data.length })}
        </div>
      </div>
    </div>
  );
};

export default AccountScanningTable;

